import React, {useCallback} from 'react'
import ListPage from '../../Components/List/ListPage'
import DropdownGroup from '../../Components/Dropdown/DropdownGroup'
import DropdownItem from '../../Components/Dropdown/DropdownItem'
import {ColInfo, ColOptions, ColPhoto, ColSelect, ColStat,} from '../../Components/List/Col'
import Dropdown from '../../Components/Dropdown'
import {ButtonIcon} from '../../Components/Button/Button'
import styles from '../../../CSS/main.css'
import UserItem from '../../Components/List/Item/UserItem'
import {useNavigation} from '../../utils/navigation'
import {useListState} from '../../Components/List/hooks'
import {INIT_USER_STATE, USER_FILTERS, USER_STATE, USER_TABS} from './filters'
import {Filters} from '../../Components/Filters'
import {User} from "../../Components/List/Item/CommentsItem";
import {getUsers, postUserAction} from "../../api/requests";
import {useAsyncCallback} from "react-async-hook";

const Users: React.VFC = () => {
  const { goBack } = useNavigation()

  const {
    params,
    setActiveTab,
    onPageChange,
    select,
    toggleAll,
    selectedItems,
    onChangeSearch,
    setListParams,
    resetState,
    items,
    pageCount,
    refetch,
    loading,
    allSelected,
    patchListParams,
  } = useListState<User, USER_STATE>(INIT_USER_STATE, getUsers)
  const { page, tab, searchTerm } = params

  const performAction = useAsyncCallback(postUserAction)
  const onAction = useCallback(async (type: string, ids: ReadonlyArray<number>) => {
    await performAction.execute(type, ids)
    refetch()
  }, [refetch])

  const onApprove = useCallback((ids: ReadonlyArray<number>) => {
    void onAction('approve', ids)
  }, [onAction])

  const onBlock = useCallback( (ids: ReadonlyArray<number>) => {
    void onAction('block', ids)
  }, [onAction])
  
  const onDisApprove = useCallback( (ids: ReadonlyArray<number>) => {
    void onAction('disapprove', ids)
  }, [onAction])

  const handleSearch = useCallback((keyword: string) => {
    patchListParams('searchTerm', keyword)
  }, [])

  return (
    <ListPage
      loading={loading}
      items={items}
      searchTerm={searchTerm}
      onChangeSearch={onChangeSearch}
      onSearch={handleSearch}
      filters={(toggle) => (
        <Filters
          filters={USER_FILTERS}
          filterState={params}
          updateParams={setListParams}
          onReset={resetState}
          onClose={toggle}
        />
      )}
      itemRenderer={(i) => (
        <UserItem
          key={i.id}
          onSelected={() => select(i)}
          selected={selectedItems.includes(i)}
          user={i}
          onApprove={() => onApprove([i.id])}
          onBlock={() => onBlock([i.id])}
          onDelete={() => onDisApprove([i.id])}
          options={
            <>
              <DropdownGroup>
                <DropdownItem onClick={() => onApprove([i.id])}>Activate user</DropdownItem>
                <DropdownItem onClick={() => onBlock([i.id])}>Ban user</DropdownItem>
              </DropdownGroup>
              <DropdownGroup>
                <DropdownItem highlighted onClick={() => onDisApprove([i.id])}>
                  Disapprove user
                </DropdownItem>
              </DropdownGroup>
            </>
          }
        />
      )}
      headerRenderer={() => (
        <>
          <ColSelect
            onChange={toggleAll}
            showActions={!!selectedItems.length}
            toggle={allSelected}>
            <Dropdown
              trigger={
                <ButtonIcon
                  title='Select Options'
                  additionalClassNames={[styles.SelectOptions]}
                />
              }
              position={'bottom'}>
              <DropdownGroup>
                <DropdownItem onClick={() => onApprove(selectedItems.map(i => i.id))}>Activate selected</DropdownItem>
                <DropdownItem onClick={() => onBlock(selectedItems.map(i => i.id))}>Ban selected</DropdownItem>
              </DropdownGroup>
              <DropdownGroup>
                <DropdownItem highlighted onClick={() => onDisApprove(selectedItems.map(i => i.id))}>
                  Disapprove selected
                </DropdownItem>
              </DropdownGroup>
            </Dropdown>
          </ColSelect>
          <ColPhoto />
          <ColInfo>
            <a href='#'>Full name</a>
          </ColInfo>
          <ColStat>
            <a href='#'>Status</a>
          </ColStat>
          <ColOptions />
        </>
      )}
      title={'Manage Users'}
      onBack={goBack}
      tabs={USER_TABS}
      activeTab={tab}
      onChangeTab={setActiveTab}
      pageCount={pageCount}
      page={page}
      onPageChange={onPageChange}
      isShowSearch
      searchType='Users'
    />
  )
}

export default Users
